import { useRef, useState } from "react";
import { Play } from "lucide-react";

/**
 * Slide-to-start button. Driver drags the knob from left to right to confirm start.
 * Works for touch (iOS/Android) and mouse.
 */
export default function SlideToStart({ label = "SLIDE TO START TRIP", onComplete, testid = "slide-start", disabled = false }) {
  const trackRef = useRef(null);
  const [pos, setPos] = useState(0);
  const [active, setActive] = useState(false);
  const [done, setDone] = useState(false);
  const startX = useRef(0);

  const onDown = (clientX) => {
    if (disabled || done) return;
    setActive(true);
    startX.current = clientX - pos;
  };
  const onMove = (clientX) => {
    if (!active || !trackRef.current) return;
    const max = trackRef.current.offsetWidth - 64;
    const x = Math.max(0, Math.min(max, clientX - startX.current));
    setPos(x);
  };
  const onUp = () => {
    if (!active || !trackRef.current) return;
    const max = trackRef.current.offsetWidth - 64;
    if (pos >= max - 10) {
      setPos(max); setDone(true); setActive(false);
      onComplete?.();
    } else {
      setPos(0); setActive(false);
    }
  };

  return (
    <div
      ref={trackRef}
      data-testid={testid}
      className={`relative h-14 rounded-full select-none overflow-hidden ${disabled ? "bg-zinc-800/60" : "bg-gradient-to-r from-amber-400/20 via-amber-400/10 to-amber-400/20 border border-amber-400/40"}`}
      onMouseMove={(e) => onMove(e.clientX)}
      onMouseUp={onUp}
      onMouseLeave={onUp}
      onTouchMove={(e) => onMove(e.touches[0].clientX)}
      onTouchEnd={onUp}
    >
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <span className={`text-xs uppercase tracking-[0.3em] font-bold ${disabled ? "text-zinc-600" : "text-amber-400"} transition-opacity ${pos > 50 ? "opacity-0" : "opacity-100"}`}>
          {disabled ? "WAITING FOR ADDRESSES" : done ? "STARTED" : label}
        </span>
      </div>
      <button
        type="button"
        disabled={disabled}
        data-testid={`${testid}-knob`}
        onMouseDown={(e) => onDown(e.clientX)}
        onTouchStart={(e) => onDown(e.touches[0].clientX)}
        className={`absolute top-1 left-1 h-12 w-12 rounded-full flex items-center justify-center font-bold transition-shadow ${disabled ? "bg-zinc-700 text-zinc-500 cursor-not-allowed" : done ? "bg-green-400 text-zinc-950 cursor-default" : "bg-amber-400 text-zinc-950 cursor-grab shadow-lg shadow-amber-400/30 active:cursor-grabbing"}`}
        style={{ transform: `translateX(${pos}px)`, transition: active ? "none" : "transform 0.25s ease" }}
      >
        <Play className="h-5 w-5 fill-current"/>
      </button>
    </div>
  );
}
